import React, { Component } from "react";
import { API } from "aws-amplify";
import axios from 'axios';
import { Form, Row, Col, Card, InputGroup, Tabs, Tab, Button, Alert, Modal, Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import '../common/Detail.css';

import EntityContactList from "containers/entity/EntityContactList";
import PropertyList from "containers/property/PropertyList";
import PropertySaleList from "containers/property/PropertySaleList";
import LeasingAgentList from "containers/property/LeasingAgentList";
import LiftOperatorList from "containers/property/LiftOperatorList";
import PropertySaleSheetList from "containers/property/PropertySaleSheetList";
import EntityFindAndReplace from "containers/entity/EntityFindAndReplace";


import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import { css } from '@emotion/core';
import { PacmanLoader } from 'react-spinners';
import Moment from "moment";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class SaleDetail extends Component {
    constructor(props) {
        super(props);

        
        this.updateTableState = this.updateTableState.bind(this);
        this.saveRecord = this.saveRecord.bind(this);
        this.refreshDataSet = this.refreshDataSet.bind(this);
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);


        this.state = {
            isLoading: null,
            isDeleting: null,
            modified: false,
            sale: null,
            showAlert: false,
            errorMessage: "",
            propertyidlist: [],

            contacts: [],
            entityLeasingAgents: [],
            entityLiftOperators: [],
            entitySales: [],
            entitySaleSheets: [],
            entityProperties: [],

            entitySalesCount: 0,
            entitySaleSheetsCount: 0,

            suburbOptions: [],
            titleOptions: [],
            countryOptions: [],
            positionOptions:[],
            entityTypeOptions:[],
            stateOptions: [{value: "ACT", label: "ACT"},{value: "NSW", label: "NSW"},{value: "NT", label: "NT"},{value: "QLD", label: "QLD"},{value: "SA", label: "SA"},{value: "TAS", label: "TAS"},{value: "VIC", label: "VIC"},{value: "WA", label: "WA"},{value: "NZ", label: "NZ"}],
            selectedState: null,
            selectedPostalState: null,

            showEntityFindAndReplace: false,

            selectedSuburb: null,
            selectedPostalSuburb: null,

            property_key: null,
            saleid: null,
            salesheetid: null,

            selectedCountry: null,
            selectedPostalCountry: null,
            selectedEntityType: null,

            entity_id : null,
            origin_entity_id: null,
            name: null,
            telephone: null,
            fax: null,
            notes: null,
            st_care_of: null,
            st_premises_xx: null,
            st_building_name_xx: null,
            st_street_number_xx: null,
            st_street_name_xx: null,
            st_address_line_1: null,
            st_address_line_2: null,
            st_suburb: null,
            st_postcode: null,
            st_state: null,
            st_country: null,
            pa_care_of: null,
            pa_po_box: null,
            pa_suburb: null,
            pa_postcode: null,
            pa_state: null,
            pa_country: null,
            internet: null,
            email: null,
            inactive: null,
            entity_type_code: null,
            entity_type: null,
            search_state: null,
            created_date: null,
            created_by: null,
            last_edited_date: null,
            last_edited_by: null
            
        };



       

    }

    

    componentWillUnmount() {
        source.cancel();
        this.setState({ entity: [] });
        this.setState({ contacts: [] });
        this.setState({ suburbOptions: [] });
       
        
    }


    async componentDidMount() {
       
        try {
            this.setState({ isLoading: false });   
            if (this.props.location.state){
                if (this.props.location.state.propertyidlist){
                    this.setState({propertyidlist: this.props.location.state.propertyidlist});
                }
            }
            if (this.props.match.params.id.indexOf("new")>=0) {
                console.log("New entity");                
                this.setState(state => ({ inactive: false }));

                this.syncroniseState();
                document.title = "New entity " ;
            }
            else {
                await this.retrieveEntity();


                try {
                    await this.getEntityContacts({entityid: this.state.entity_id});
                }
                catch{
                    alert("Error loading contacts");
                }
                try {
                    this.getEntityLeasingAgents({entityid: this.state.entity_id});
                }
                catch{
                    alert("Error loading leasing agents");
                }

                try {
                    this.getEntityLiftOperators({entityid: this.state.entity_id});
                }
                catch{
                    alert("Error loading lift operators");
                }
                try {
                    this.getEntitySales({entityid: this.state.entity_id});
                }
                catch{
                    alert("Error loading sales");
                }

                try {
                    this.getEntitySalesSheets({entityid: this.state.entity_id});
                }
                catch{
                    alert("Error loading sale sheets");
                }
                try {
                    this.getEntityProperties({entityid: this.state.entity_id});
                }
                catch{
                    alert("Error loading properties");
                }

                if(this.state.entity_type_code!=null){
                    this.setState({ selectedEntityType: { value: this.state.entity_type_code, label: this.state.entity_type } });
                }

                document.title = "Entity " + this.state.name;
                
            }
            
            if (this.props.location.search.indexOf("cityscopereference=")>0)
            {
                console.log("Found property key");
                this.setState(state => ({ property_key: this.props.location.search.replace("?cityscopereference=", "") }));
            }
            if (this.props.location.search.indexOf("saleid=")>0){
                this.setState(state => ({ sale_id: this.props.location.search.replace("?saleid=", "") }));
            }
            if (this.props.location.search.indexOf("salesheetid=")>0){
                this.setState(state => ({ sale_sheet_id: this.props.location.search.replace("?salesheetid=", "") }));
            }

            if(this.state.st_suburb!=null){
                this.setState({ selectedSuburb: { value: this.state.st_suburb+" ("+this.state.st_state+")", label: this.state.st_suburb+" ("+this.state.st_state+")" } });
            }
            if(this.state.pa_suburb!=null){
                this.setState({ selectedPostalSuburb: { value: this.state.pa_suburb+" ("+this.state.pa_state+")", label: this.state.pa_suburb+" ("+this.state.pa_state+")" } });
            }

            const suburbOptions = await this.getSuburbs();
            if (suburbOptions) {
                this.setState({ suburbOptions });
            }

            const titleOptions = await this.getTitles();
            if (titleOptions) {
                this.setState({ titleOptions });
            }

            const positionOptions = await this.getPositions();
            if (positionOptions) {
                this.setState({ positionOptions });
            }

            const entityTypeOptions = await this.getEntityTypeOptions();
            if (entityTypeOptions){
                this.setState({entityTypeOptions});
            }
            
            this.setState({ selectedState: { value: this.state.st_state, label: this.state.st_state } });
            this.setState({ selectedPostalState: { value: this.state.pa_state, label: this.state.pa_state } });
            this.setState({ selectedCountry: { value: this.state.st_country, label: this.state.st_country } });
            this.setState({ selectedPostalCountry: { value: this.state.pa_country, label: this.state.pa_country } });

            

            const countryOptions = await this.getCountries();
            if (countryOptions) {
                this.setState({ countryOptions });
            }
            

            
          //  this.setState({ isLoading: false });   
        } catch (e) {
            alert(e);
        }
    }

    syncroniseState() {

        const entity = {
            entity_id: this.state.entity_id,
            origin_entity_id: this.state.origin_entity_id,
            name: this.state.name,
            telephone: this.state.telephone,
            fax: this.state.fax,
            notes: this.state.notes,
            st_care_of: this.state.st_care_of,
            st_premises_xx: this.state.st_premises_xx,
            st_building_name_xx: this.state.st_building_name_xx,
            st_street_number_xx: this.state.st_street_number_xx,
            st_street_name_xx: this.state.st_street_name_xx,
            st_address_line_1: this.state.st_address_line_1,
            st_address_line_2: this.state.st_address_line_2,
            st_suburb: this.state.st_suburb,
            st_postcode: this.state.st_postcode,
            st_state: this.state.st_state,
            st_country: this.state.st_country,
            pa_care_of: this.state.pa_care_of,
            pa_po_box: this.state.pa_po_box,
            pa_suburb: this.state.pa_suburb,
            pa_postcode: this.state.pa_postcode,
            pa_state: this.state.pa_state,
            pa_country: this.state.pa_country,
            internet: this.state.internet,
            email: this.state.email,
            inactive: this.state.inactive,
            entity_type_code: this.state.entity_type_code,
            entity_type: this.state.entity_type,
            search_state: this.state.search_state,
            created_date: this.state.created_date,
            created_by: this.state.created_by,
            last_edited_date: this.state.last_edited_date,
            last_edited_by: this.state.last_edited_by
        };

        this.setState({ entity });
    }

    async retrieveEntity() {
        const entity = await this.getEntity();

        const { entity_id,
            origin_entity_id,
            name,
            telephone,
            fax,
            notes,
            st_care_of,
            st_premises_xx,
            st_building_name_xx,
            st_street_number_xx,
            st_street_name_xx,
            st_address_line_1,
            st_address_line_2,
            st_suburb,
            st_postcode,
            st_state,
            st_country,
            pa_care_of,
            pa_po_box,
            pa_suburb,
            pa_postcode,
            pa_state,
            pa_country,
            internet,
            email,
            inactive,
            entity_type_code,
            entity_type,
            search_state,
            created_date,
            created_by,
            last_edited_date,
            last_edited_by } = entity;

        this.setState({
            entity,
            entity_id,
            origin_entity_id,
            name,
            telephone,
            fax,
            notes,
            st_care_of,
            st_premises_xx,
            st_building_name_xx,
            st_street_number_xx,
            st_street_name_xx,
            st_address_line_1,
            st_address_line_2,
            st_suburb,
            st_postcode,
            st_state,
            st_country,
            pa_care_of,
            pa_po_box,
            pa_suburb,
            pa_postcode,
            pa_state,
            pa_country,
            internet,
            email,
            inactive,
            entity_type_code,
            entity_type,
            search_state,
            created_date,
            created_by,
            last_edited_date,
            last_edited_by
        });
    }


    //Call API
    getEntity() {
        console.log("inside of getEntity");
        return API.get("colin", `/entities/${this.props.match.params.id}`, { cancelToken: source.token }).then(response => {
            return response;
        }).catch(error => {
            console.log(error)
        });
           
    }

    async saveEntity(entity) {
      
        this.setState({ last_edited_by: this.props.user });
        if (this.props.match.params.id === "new" && this.state.entity_id === null) {
            this.setState({ created_by: this.props.user });
            const response =  await API.post("colin", `/entities/new`, { body: entity });
            try {
                return await response;
    
            } catch (error) {
                alert(error+". Please refresh the page (F5) to try again.")
            };
        }
        const response =  API.put("colin", `/entities/${this.state.entity_id}`, { body: entity  });
        try {
            return await response;

        } catch (error) {
            alert(error+". Please refresh the page (F5) to try again.")
        };
    }




    getEntityContacts(filter) {
        try {
            API.get("colin", `/entities/${this.state.entity_id}/contacts`, { 'queryStringParameters': filter }).then((contacts) => {
                if (contacts) {
                    this.setState(state => ({ contacts }));
                }
            });
        }
        catch{
            console.log("Error getting agents");
        }
    }

    getEntityLeasingAgents(filter) {
        try {
            API.get("colin", "/entityleasingagents", { 'queryStringParameters': filter, 'cancelToken': source.token  }).then((entityLeasingAgents) => {
                if (entityLeasingAgents) {
                    entityLeasingAgents.sort((a,b) => (a.property_key > b.property_key) ? 1 : ((b.property_key > a.property_key) ? -1 : 0)) ;
                    this.setState(state => ({ entityLeasingAgents }));
                }
            });
        }
        catch{
            console.log("Error getting leasing agents");
        }
    }
    

    getEntityLiftOperators(filter) {
        try {
            API.get("colin", "/entityliftoperators", { 'queryStringParameters': filter, 'cancelToken': source.token  }).then((entityLiftOperators) => {
                if (entityLiftOperators) {
                    entityLiftOperators.sort((a,b) => (a.property_key > b.property_key) ? 1 : ((b.property_key > a.property_key) ? -1 : 0)) ;
                    this.setState(state => ({ entityLiftOperators }));
                }
            });
        }
        catch{
            console.log("Error getting lift operators");
        }
    }

    getEntitySalesSheets(filter) {
        try {
            API.get("colin", "/entitysalesheets", { 'queryStringParameters': filter, 'cancelToken': source.token  }).then((entitySaleSheets) => {
                
                if (entitySaleSheets) {
                    entitySaleSheets.sort((a,b) => (a.property_key > b.property_key) ? 1 : ((b.property_key > a.property_key) ? -1 : 0)) ;
                    entitySaleSheets.sort((a,b) => b.current ? 1 : a.current  ? -1 : 0) ;
                    
                    this.setState(state => ({ entitySaleSheets }));
                    var activeEntitySaleSheets = entitySaleSheets.filter(function (entitySaleSheet) {
                        return entitySaleSheet.current === true;
                    });
                    this.setState(state => ({ activeEntitySaleSheets }));

                    if (entitySaleSheets.length > 0) {
                        this.setState({ entitySaleSheetsCount: entitySaleSheets[0].sales_sheets_count });
                    }

                }
            });
        }
        catch{
            console.log("Error getting sale sheets");
        }
    }
    getEntitySales(filter) {
        try {
            API.get("colin", `/entitysales`, { 'queryStringParameters': filter, 'cancelToken': source.token  }).then((entitySales) => {
                if (entitySales) {
                    entitySales.sort((a,b) => b.last_sale ? 1 : a.last_sale ? -1 : 0) ;
                    entitySales.sort((a,b) => (a.property_key > b.property_key) ? 1 : ((b.property_key > a.property_key) ? -1 : 0)) ;
                    this.setState(state => ({ entitySales }));

                    if (entitySales.length > 0) {
                        this.setState({ entitySalesCount: entitySales[0].sales_count });
                    }
                }
            });
        }
        catch{
            console.log("Error getting sales");
        }
    }
    
    getEntityProperties(filter) {
        try {
            API.get("colin", `/properties`, { 'queryStringParameters': filter, 'cancelToken': source.token  }).then((entityProperties) => {
                if (entityProperties) {
                    entityProperties.sort((a,b) => (a.property_key > b.property_key) ? 1 : ((b.property_key > a.property_key) ? -1 : 0)) ;
                    this.setState(state => ({ entityProperties }));
                }
            });
        }
        catch{
            console.log("Error getting properties");
        }
    }
    

    getSuburbs() {
        return API.get("colin", `/suburbs`);
    }

    getTitles() {
        return API.get("colin", `/salutations`);
    }

    getCountries() {
        return API.get("colin", `/countries`);
    }


    getPositions() {
        return API.get("colin", `/positions`);
    }

   
    getEntityTypeOptions() {
        return API.get("colin", `/entitytypes`);
    }


    handleEntityTypeChange =(selectedEntityType)=>{
        
        if (selectedEntityType) {
            this.setState({ selectedEntityType
                        , entity_type_code: selectedEntityType.value
                        , modified: true },this.handleBlur);
        }
        else {
            this.setState({ selectedEntityType: { value: null, label: null } 
                        ,selectedEntityType: null 
                        , modified: true },this.handleBlur);
        }

    }

    
    handleStreetAddressClear =async event => {
        this.setState({ st_care_of: "" 
        ,st_address_line_1: "" 
        ,st_address_line_2 : "" 
        ,st_suburb : "" 
        ,st_postcode: ""
        ,st_state: ""
        ,st_country: "" 
        ,selectedSuburb: {value: "", label: ""}
        ,selectedState: { value: "", label: "" }  
        ,selectedCountry: { value: "", label: "" }  
        ,search_state: ""
        ,modified: true },
        this.handleBlur);

    }

    handlePostalAddressClear = async event =>  {
        this.setState({ pa_care_of: ""
        , pa_po_box: "" 
        , pa_suburb: ""
        , pa_postcode: ""
        , pa_state: "" 
        , pa_country: "" 
        , selectedPostalSuburb :{value: "", label: ""}
        , selectedPostalCountry :{ value: "", label: "" }   
        , modified: true },
        this.handleBlur);
    }


    handleCountryChange = (selectedCountry) => {
        
        if (selectedCountry) {
            this.setState({ selectedCountry 
                            ,st_country: selectedCountry.value 
                            , modified: true },this.handleBlur);
        }
        else {
            this.setState({ selectedCountry: { value: null, label: null }
                            , st_country: null 
                            , modified: true },this.handleBlur);
        }

    }

    handlePostalCountryChange = (selectedPostalCountry) => {
        
        
        if (selectedPostalCountry) {
            this.setState({ selectedPostalCountry 
                            ,pa_country: selectedPostalCountry.value 
                            , modified: true },this.handleBlur);
        }
        else {
            this.setState({ selectedPostalCountry: { value: null, label: null }
                            , pa_country: null 
                            , modified: true },this.handleBlur);
        }

    }



    handleSuburbChange = (selectedSuburb) => {
        
        if (selectedSuburb) {
            this.setState({ selectedSuburb
                        , st_suburb: selectedSuburb.suburb 
                        , st_state: selectedSuburb.state
                        , search_state: selectedSuburb.search_state
                        , selectedState:  { value: selectedSuburb.state, label: selectedSuburb.state }
                        , st_postcode: selectedSuburb.postcode 
                        , modified: true },this.handleBlur);
        }
        else {
            this.setState({ selectedSuburb: { value: null, label: null }
                            ,selectedState: { value: null, label: null }
                            ,st_suburb: null
                            , st_state: null
                            , search_state: null
                            , st_postcode: null 
                            , modified: true },this.handleBlur);
        }
    }

    handleSuburbInputChange = event => {     
        let suburbOptions = [...this.state.suburbOptions];
        suburbOptions.push({
            value: event, label: event
        });
        this.setState({ suburbOptions 
                        , selectedSuburb: { value: event, label: event } 
                        , st_suburb: event
                        , modified: true },this.handleBlur);
       
    }

    handleStateChange = (selectedState) => {
        this.setState({ modified: true });
        if (selectedState) {
            this.setState({ selectedState });
            
            this.setState({ st_state: selectedState.value, search_state: selectedState.value });            
        }
        else {
            this.setState({ selectedState: { value: null, label: null } });
            this.setState({ st_state: "", search_state:"" });
            
        }
    }
    
    handleStateInputChange = event => {
        this.setState({ st_state: event });
        
        let stateOptions = [...this.state.stateOptions];
        stateOptions.push({
            value: event, label: event
        });
        this.setState(state => ({ stateOptions }));        
        this.setState(state => ({ selectedState: { value: event, label: event } }));
        this.setState({ modified: true });
    }

    

    handlePostalSuburbChange = (selectedPostalSuburb) => {
        
        if (selectedPostalSuburb) {
        this.setState({ selectedPostalSuburb
                        ,pa_suburb: selectedPostalSuburb.suburb
                        ,pa_state: selectedPostalSuburb.state
                        ,selectedPostalState: { value: selectedPostalSuburb.state, label: selectedPostalSuburb.state }
                        ,pa_postcode: selectedPostalSuburb.postcode 
                        , modified: true },this.handleBlur);
    }
        else {
            this.setState({ selectedPostalSuburb: { value: null, label: null }
                            ,pa_suburb: null
                            ,pa_state: null 
                            ,selectedPostalState: { value: null, label: null }
                            ,pa_postcode: null 
                            ,modified: true },this.handleBlur);
        }

    }

    handlePostalSuburbInputChange = event => {
        let suburbOptions = [...this.state.suburbOptions];
        suburbOptions.push({
            value: event, label: event
        });
        this.setState({ suburbOptions 
                                ,selectedPostalSuburb: { value: event, label: event } 
                                ,pa_suburb: event
                                , modified: true },this.handleBlur);
        
    }


    handlePostalStateChange = (selectedPostalState) => {
        this.setState({ modified: true });
        if (selectedPostalState) {
            this.setState({ selectedPostalState });
            
            this.setState({ pa_state: selectedPostalState.value });            
        }
        else {
            this.setState({ selectedPostalState: { value: null, label: null } });
            this.setState({ pa_state: "" });
            
        }
    }
    
    handlePostalStateInputChange = event => {
        this.setState({ pa_state: event });
        
        let stateOptions = [...this.state.stateOptions];
        stateOptions.push({
            value: event, label: event
        });
        this.setState(state => ({ stateOptions }));        
        this.setState(state => ({ selectedPostalState: { value: event, label: event } }));
        this.setState({ modified: true });
    }


    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }

    handlePercentChange = event => {
        let val = event.target.value.replace(/[^0-9.%]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true });
    }

    handleNumberChange = event => {
        let val = event.target.value.replace(/[^0-9.]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true });
    }

    handleMoneyChange = event => {
        let val = event.target.value.replace(/[^0-9.,$]/g, "");
        this.setState({
            [event.target.id]: val
        });
        this.setState({ modified: true });
    }



    handleDateChange(date, name) {
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(date);
        
        if (date) {
            this.setState({
                [name]: dt.toLocaleDateString('en-AU',options)
                , modified: true
            });
        }
        else {
            this.setState({
                [name]: null
                , modified: true });
        }
        
    }


    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
            , modified: true },this.handleBlur);
        
    }

   

    validateRelatedRecord(record, set) {
        //property
        if (set === "entity") {

            //Entity code
            if (!this.state.origin_entity_id) {
                return [false, "You must enter a entity code."];
            }

            if (!this.state.name) {
                return [false, "You must enter a entity name."];
            }
            if (!this.state.st_state) {
                return [false, "You must enter a state."];
            }
            else if(['ACT','NSW','NT','QLD','SA','TAS','VIC','WA','NZ'].indexOf(this.state.st_state)===-1 && this.state.search_state==null){
                return [true, "You have entered a state outside of the standard Australia and NZ states. The record has been saved but finding this entity in other parts of the system will be more difficult."];
            }

            



            if (this.state.email) {
                if (!this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    return [false, "The email is not a correct format"];
                }
            }
    
            if(this.state.internet){
                if(!this.state.internet.match(/^[\w.-]{3}(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)){
                    return [false, "The url (website) is not a correct format. Please enter www.{}.{}"];
                }

            }

        }

        if (set === "contacts") {

            // secondly check that UnitSort has been specified if required

            if (!record.entity_id) {
                return [false, "Enter a entity id."];
            }

            if (!record.first_name && !record.surname) {
                return [false, "Enter a firstname or lastname."];
            }

            if (record.email) {
                if (!record.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    return [false, "The email is not a correct format"];
                }
            }


        }

        return [true,];
    }


    handleBlur = async event => {
        console.log("Inside handle blur");
        
        if (this.state.modified === true) {
            this.setState({ showAlert: false });

            
            
            await this.syncroniseState();
            


            const validation = this.validateRelatedRecord(this.state.entity, "entity");
            console.log(validation)
            if (validation[0] === true) {
                if (validation[1]){
                    this.setState({ errorMessage: validation[1] });
                    this.setState({ showAlert: true });
                }
                try {
                    this.setState(state => ({ modified: false }));
                    if (this.props.match.params.id === "new") {
                        this.setState({ isLoading: true });
                    }
                    console.log("Saving entity");
                    const result = await this.saveEntity(this.state.entity);
                    this.setState({ isLoading: false });
                    if (result.result === false) {
                        alert(result.error_message);
                    }
                    else {
                        if (this.props.match.params.id === "new") {
                            this.setState(state => ({ entity_id: result.id }));
                            //Create relation to property
                            
                            this.props.history.push("/entities/" + this.state.entity_id);
                        }
                    }



                } catch (e) {
                    alert(e);

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }

        }

    }

    


    refreshDataSet = async (dataset) => {
        //Get nabers records
        console.log("Inside refresh ");

       
    }

    



    updateTableState(data, set) {
        this.setState({
            [set]: data
        });
    }

    saveRecord(record, endpoint, id) {
        console.log("Inside save record");
        record.last_edited_by = this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                return API.post("colin", `/entities/${this.state.entity_id}/${endpoint.toLowerCase()}/new`, {
                    body: record
                });
            }
        }
        //If not a new record and updating an existing, perform a put
        return API.put("colin", `/entities/${this.state.entity_id}/${endpoint.toLowerCase()}/${record[id]}`, {
            body: record
        }
        );
    }


    
    

  

    handleDelete = async event => {
        event.preventDefault();
        if (event.detail !== 0) {
            
            const confirmed = window.confirm(
                "Are you sure you want to delete this entity"
            );

            if (!confirmed) {
                return;
            }
            else {
                this.setState({ archived_date: new Date() }, () =>
                    this.syncroniseState().then(async () => {
                        const result = await this.saveEntity(this.state.entity);
                        if (result.result === false) {
                            alert(result.error_message);
                        }
                        else {

                            this.props.history.push("/");
                        }
                    }
                    )
                );

            }

            
        }
    }


    handleEnityFindAndReplace = event =>{
        
        this.setState({ showEntityFindAndReplace: !this.state.showEntityFindAndReplace });
     }



    

    render() {
        return (
            
            <div className="Entity">
                {this.state.isLoading &&
                <div className="outer-div"><div className='sweet-loading inner-div' >
                    <PacmanLoader
                        css={css`
                        display: block;
                        margin: 0 auto;
                        border-color: red`}
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                    />
                </div> 
                </div>
                }
                {this.state.showEntityFindAndReplace &&
                    <Modal
                    show={this.state.showEntityFindAndReplace}
                    onHide={this.handleEnityFindAndReplace}
                    dialogClassName="modal-90w"
                    >
                    <Modal.Header closeButton>
                        <Modal.Title>Find &amp; Replace Entity</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <EntityFindAndReplace 
                        isAuthenticated={this.props.isAuthenticated}
                        user={this.props.user}
                        entityid={this.state.entity_id}
                        />
            
                        </Modal.Body>
                </Modal>
                }
                {this.state.entity && this.props.isAuthenticated && !this.state.isLoading &&
                    <div className="EntityForm">
              
                    <Form  >
                        <Row>
                            <h6>Entity Details - {this.state.name} | {this.state.telephone} | {this.state.st_state} {this.state.inactive && " ** INACTIVE **"} </h6>
                    </Row>
                            <Row>
                            <Col>
                             <Nav className="justify-content-end " >
                            <Nav.Item  >
                                 <a target="_blank" href="/salutations">
                                 <Button
                                     variant="primary"                                  
                                     type="button"
                                     size="sm"
                                 >Add/Edit Salutations</Button>{" "}
                                </a>
                                  </Nav.Item>
                                  <Nav.Item  >
                                 <a target="_blank" href="/positions">
                                 <Button
                                     variant="primary"                                  
                                     type="button"
                                     size="sm"
                                 >Add/Edit Positions</Button>{" "}
                                </a>
                                  </Nav.Item>
                            {this.state.property_key &&
                            <Nav.Item  >
                                

                                <LinkContainer to={ {pathname: `/properties/${this.state.property_key}`, state: {data: this.state.propertyidlist}}} >
                                            <Button type="button" variant="primary"  size="sm">Back to Property {this.state.property_key}</Button></LinkContainer>{" "}

                                </Nav.Item  >
                            }
                            {this.state.sale_id &&
                            <Nav.Item  >
                                <LinkContainer to={`../sales/${this.state.sale_id}`}   >
                                    <Button size="sm" type="button" variant="secondary">
                                        Return to Sale {this.state.sale_id}
                                    </Button>
                                </LinkContainer>
                                </Nav.Item  >
                            }
                            {this.state.sale_sheet_id &&
                            <Nav.Item  >
                                <LinkContainer to={`../salesheets/${this.state.sale_sheet_id}`}   >
                                    <Button size="sm" type="button" variant="secondary">
                                        Return to Sale Sheet {this.state.sale_sheet_id}
                                    </Button>
                                </LinkContainer>
                                </Nav.Item  >
                            }
                            <Nav.Item  >
                            <Button type="button" size="sm" onClick={this.handleEnityFindAndReplace}>Entity Find &amp; Replace</Button>
                            </Nav.Item>
                            </Nav>
                            </Col>
                        </Row>
                    <Row  id="detail">
                            <Col>
                            <Modal show={this.state.showAlert  && this.state.entity_id? true: false} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                                <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                                <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                            </Modal>
                            {this.state.showAlert && !this.state.entity_id &&
                                <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                                <Tabs defaultActiveKey={0} id="tabset">
                                <Tab eventKey={0} title="Entity Detail">
                            <Card id="entitydetails"  >
                                <Card.Header>
                                        Entity Details +  {this.state.entity_name}
                                </Card.Header>
                                
                                    <Card.Body>

                                        
                                    <Form.Row >

                                        <Col sm={12} md={6} lg={3}>
                                            <Card id="col1head1"  >
                                                <Card.Header> Heading </Card.Header>

                                                <Card.Body>

                                                    <Form.Group as={Row} controlId="entity_id" >
                                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>ID</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                readOnly
                                                                value={this.state.entity_id}
                                                                as="input"
                                                                type="text"

                                                            />
                                                        </Col>
                                                    </Form.Group>

                                                    <Form.Group as={Row} controlId="origin_entity_id" >
                                                        <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>* Entity Code</Form.Label>
                                                        <Col>
                                                            <Form.Control
                                                                onChange={this.handleChange}
                                                                value={this.state.origin_entity_id}
                                                                as="input"
                                                                type="text"
                                                                    onBlur={this.handleBlur}
                                                            />
                                                        </Col>

                                                            </Form.Group>

                                                            <Form.Group as={Row} controlId="inactive" >
                                                                <Form.Label className="text-right" column sm={6} md={6} lg={4}>Inactive</Form.Label>
                                                                <Col >
                                                                    <Form.Check checked={this.state.inactive}
                                                                        onChange={this.handleCheckBoxChange}
                                                                        label=""
                                                                        type="checkbox"
                                                                        name="inactive"
                                                                        onBlur={this.handleBlur}
                                                                    />
                                                                </Col>

                                                            </Form.Group>

                                                            <Form.Group as={Row} controlId="name" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>* Name</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.name}
                                                                        as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}

                                                                    />
                                                                </Col>

                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="telephone" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Telephone</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                    onChange={this.handleChange}
                                                                        value={this.state.telephone}
                                                                        as="input"
                                                                        type="text"
                                                                    onBlur={this.handleBlur}
                                                                    />
                                                                </Col>

                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="fax" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Fax</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                    onChange={this.handleChange}
                                                                        value={this.state.fax}
                                                                        as="input"
                                                                        type="text"
                                                                    onBlur={this.handleBlur}
                                                                    />
                                                                </Col>

                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="email" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Email</Form.Label>
                                                                <Col>
                                                                    <InputGroup>
                                                                        <InputGroup.Prepend><InputGroup.Text>@</InputGroup.Text></InputGroup.Prepend>
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.email}
                                                                        as="input"
                                                                        type="email"
                                                                        onBlur={this.handleBlur}

                                                                        />
                                                                        </InputGroup>
                                                                </Col>
                                                            </Form.Group>

                                                            <Form.Group as={Row} controlId="internet" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Internet</Form.Label>
                                                                <Col>
                                                                    <InputGroup>
                                                                        <InputGroup.Prepend><InputGroup.Text>www.</InputGroup.Text></InputGroup.Prepend>
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.internet}
                                                                        as="input"
                                                                        type="text"
                                                                        onBlur={this.handleBlur}
                                                                        />
                                                                        </InputGroup>
                                                                </Col>
                                                            </Form.Group>


                                                            
                                                </Card.Body>
                                            </Card>

                                        </Col>


                                        <Col sm={12} md={6} lg={3}>
                                            <Card id="col2head1"  >
                                                <Card.Header>Street Address </Card.Header>

                                                <Card.Body>
                                                        
                                                        <Form.Group as={Row} controlId="st_care_of" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Care Of</Form.Label>
                                                            <Col>

                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.st_care_of}
                                                                    as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                />

                                                            </Col>
                                                        </Form.Group>
                                                            <Form.Group as={Row} controlId="st_address_line_1" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Address Line 1</Form.Label>
                                                                <Col>
                                                                    
                                                                        <Form.Control
                                                                            onChange={this.handleChange}
                                                                            value={this.state.st_address_line_1}
                                                                            as="input"
                                                                            type="text"
                                                                    onBlur={this.handleBlur}
                                                                        />
                                                                    
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="st_address_line_2" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Address Line 2</Form.Label>
                                                                <Col>

                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.st_address_line_2}
                                                                        as="input"
                                                                        type="text"
                                                                    onBlur={this.handleBlur}
                                                                    />

                                                                </Col>
                                                            </Form.Group>

                                                            <Form.Group as={Row} controlId="st_suburb" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Suburb</Form.Label>
                                                                <Col>
                                                                <CreatableSelect
                                                                        value={this.state.selectedSuburb}
                                                                        onChange={this.handleSuburbChange}
                                                                        options={this.state.suburbOptions}
                                                                    onCreateOption={this.handleSuburbInputChange}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                    />
                                                                </Col>

                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="st_state" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>* State</Form.Label>
                                                                <Col>
                                                                <CreatableSelect
                                                                        value={this.state.selectedState}
                                                                        onChange={this.handleStateChange}
                                                                        options={this.state.stateOptions}
                                                                        onCreateOption={this.handleStateInputChange}
                                                                        onBlur={this.handleBlur}
                                                                        isClearable
                                                                    />

                                                                    {/* <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.st_state}
                                                                        as="input"
                                                                    type="text"
                                                                    onBlur={this.handleBlur}
                                                                        
                                                                    /> */}
                                                                </Col>

                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="st_postcode" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Postcode</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.st_postcode}
                                                                        as="input"
                                                                        type="text"
                                                                    onBlur={this.handleBlur}
                                                                    />
                                                                </Col>

                                                            </Form.Group>

                                                            <Form.Group as={Row} controlId="st_country" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Country</Form.Label>
                                                                <Col>
                                                                <Select
                                                                    value={this.state.selectedCountry}
                                                                    onChange={this.handleCountryChange}
                                                                    options={this.state.countryOptions}
                                                                    onInputChange={this.handleInputChange}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                    
                                                                />
                                                                </Col>

                                                            </Form.Group>
                                                    <Row><Col  sm={6} md={6} lg={4}></Col>
                                                    <Col >
                                                        <Button
                                                            variant="secondary"
                                                            onClick={this.handleStreetAddressClear}
                                                            size="sm"
                                                            type="button"
                                                        >Clear</Button>
                                                        </Col>
                                                    </Row>

                                                </Card.Body>
                                            </Card>
                                        </Col>


                                        


                                        <Col sm={12} md={6} lg={3}>
                                            <Card id="col4head1"  >
                                                <Card.Header>Postal Address </Card.Header>

                                                <Card.Body>

                                                            <Form.Group as={Row} controlId="pa_care_of" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Care Of</Form.Label>
                                                                <Col>

                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.pa_care_of}
                                                                        as="input"
                                                                        type="text"
                                                                    onBlur={this.handleBlur}
                                                                    />

                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="pa_po_box" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>PO Box</Form.Label>
                                                                <Col>

                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.pa_po_box}
                                                                        as="input"
                                                                        type="text"
                                                                    onBlur={this.handleBlur}
                                                                    />

                                                                </Col>
                                                            </Form.Group>

                                                            <Form.Group as={Row} controlId="pa_suburb" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Suburb</Form.Label>
                                                                <Col>
                                                                <CreatableSelect
                                                                        value={this.state.selectedPostalSuburb}
                                                                    onChange={this.handlePostalSuburbChange}
                                                                        options={this.state.suburbOptions}
                                                                    onCreateOption={this.handlePostalSuburbInputChange}
                                                                    onBlur={this.handleBlur}

                                                                    isClearable
                                                                    />
                                                                </Col>

                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="pa_state" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>State</Form.Label>
                                                                <Col>
                                                                <CreatableSelect
                                                                        value={this.state.selectedPostalState}
                                                                        onChange={this.handlePostalStateChange}
                                                                        options={this.state.stateOptions}
                                                                        onCreateOption={this.handlePostalStateInputChange}
                                                                        onBlur={this.handleBlur}
                                                                        isClearable
                                                                    />
                                                                    {/* <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.pa_state}
                                                                        as="input"
                                                                        type="text"
                                                                    onBlur={this.handleBlur}
                                                                    /> */}
                                                                </Col>

                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="pa_postcode" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Postcode</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.pa_postcode}
                                                                        as="input"
                                                                        type="text"
                                                                    onBlur={this.handleBlur}
                                                                    />
                                                                </Col>

                                                            </Form.Group>

                                                            <Form.Group as={Row} controlId="pa_country" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Country</Form.Label>
                                                                <Col>
                                                                <Select
                                                                    value={this.state.selectedPostalCountry}
                                                                    onChange={this.handlePostalCountryChange}
                                                                    options={this.state.countryOptions}
                                                                    onInputChange={this.handleInputChange}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                />
                                                                </Col>

                                                            </Form.Group>
                                                            <Row><Col  sm={6} md={6} lg={4}></Col>
                                                    <Col >
                                                        <Button
                                                            variant="secondary"
                                                            onClick={this.handlePostalAddressClear}
                                                            size="sm"
                                                            type="button"
                                                        >Clear</Button>
                                                        </Col>
                                                    </Row>

                                                </Card.Body>
                                                </Card>

                                        </Col>

                                            <Col sm={12} md={6} lg={3}>
                                                <Card id="col3head1"  >
                                                    <Card.Header> Notes </Card.Header>

                                                    <Card.Body>
                                                    <Form.Group as={Row} controlId="entity_type_code" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Entity Type</Form.Label>
                                                                <Col>
                                                                <Select
                                                                    value={this.state.selectedEntityType}
                                                                    onChange={this.handleEntityTypeChange}
                                                                    options={this.state.entityTypeOptions}
                                                                    onInputChange={this.handleInputChange}
                                                                    onBlur={this.handleBlur}
                                                                    isClearable
                                                                    
                                                                />
                                                                </Col>

                                                            </Form.Group>


                                                            <Form.Group as={Row} controlId="notes" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Notes</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.notes}
                                                                        as="textarea"
                                                                        rows="8"
                                                                    onBlur={this.handleBlur}
                                                                    />
                                                                </Col>

                                                            </Form.Group>
                                                            <Form.Group as={Row} controlId="search_state" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Search State</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                        readOnly
                                                                        value={this.state.search_state}
                                                                        as="input"
                                                                    type="text"
                                                                    

                                                                    />
                                                                </Col>

                                                            </Form.Group>
                                                      
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                    </Form.Row>

                                        
                                        

                                        
                                    



                                         


                                   






                                </Card.Body>
                            
                        </Card >
                      </Tab>
                               

                                    <Tab eventKey={1} title="Contacts">


                                        <Card >
                                            <Card.Body>
                                                <EntityContactList
                                                    isAuthenticated={this.props.isAuthenticated}
                                                    user={this.props.user}
                                                    data={this.state.contacts}
                                                    updateTableState={this.updateTableState}
                                                    saveRecord={this.saveRecord}
                                                    deleteRecord={this.deleteRecord}
                                                    refreshDataSet={this.refreshDataSet}
                                                    titleOptions={this.state.titleOptions}
                                                    validateRelatedRecord={this.validateRelatedRecord}
                                                    entityid={this.state.entity_id}
                                                    positionOptions={this.state.positionOptions}
                                                />
                                            </Card.Body>
                                        </Card>
                                    </Tab>
                                    <Tab eventKey={2} title={"Managing Agents (" + this.state.entityProperties.length + ")"}>
                                            <Card >
                                                {/* <Card.Header >Sales

                                                </Card.Header> */}

 
                                                <PropertyList
                                                    isAuthenticated={this.props.isAuthenticated}
                                                    user={this.props.user}
                                                    data={this.state.entityProperties}
                                                    updateTableState={this.updateTableState}
                                                    controlType="table2"
                                                    saveRecord={this.saveRecord}
                                                    deleteRecord={this.deleteRecord}
                                                    refreshDataSet={this.refreshDataSet}
                                                    validateRelatedRecord={this.validateRelatedRecord}
                                                    propertyid={this.state.property_id}
                                                    propertykey={this.state.property_key}
                                                />
                                                                                               
                                            </Card>


                                        </Tab>
                                    <Tab eventKey={3} title={"Leasing Agents (" + this.state.entityLeasingAgents.length + ")"}>

                                        <Card >
                                            {/* <Card.Header >

                                                For Lease ({this.state.leasingAgents.length})

                                            </Card.Header> */}

                                        
                                                <Card.Body>


                                                    <Card >
                                                        <Card.Body>
                                                            <LeasingAgentList
                                                                isAuthenticated={this.props.isAuthenticated}
                                                                user={this.props.user}
                                                                data={this.state.entityLeasingAgents}
                                                                updateTableState={this.updateTableState}
                                                                saveRecord={this.saveRecord}
                                                                deleteRecord={this.deleteRecord}
                                                                refreshDataSet={this.refreshDataSet}
                                                                validateRelatedRecord={this.validateRelatedRecord}
                                                                getAgentsLeasing={this.getAgentsLeasing}
                                                                getLeasingAgentContacts={this.getLeasingAgentContacts}
                                                                leasingAgentOptions={this.state.leasingAgentOptions}
                                                                leasingAgentContactOptions={this.state.leasingAgentContactOptions}
                                                                propertyid={this.state.property_id}
                                                                propertykey={this.state.property_key}
                                                                controlType="table2"
                                                            />
                                                        </Card.Body>
                                                    </Card>                                                   

                                                </Card.Body>
                                            
                                        </Card>


                                        </Tab>
                                         <Tab eventKey={4} title={"Lift Operators (" + this.state.entityLiftOperators.length + ")"}>
                                            <Card >
                                                {/* <Card.Header >

                                                    Lift Operators ({this.state.liftOperators.length})

                                                </Card.Header>
                                                 */}
                                                    <Card.Body>
                                                        <Card >
                                                            <Card.Body>
                                                                <LiftOperatorList
                                                                    isAuthenticated={this.props.isAuthenticated}
                                                                    user={this.props.user}
                                                                    data={this.state.entityLiftOperators}
                                                                    updateTableState={this.updateTableState}
                                                                    saveRecord={this.saveRecord}
                                                                    deleteRecord={this.deleteRecord}
                                                                    refreshDataSet={this.refreshDataSet}
                                                                    liftOperatorOptions={[]}
                                                                    controlType="table2"
                                                                    filter={this.state.liftOperatorFilter}
                                                                    validateRelatedRecord={this.validateRelatedRecord}
                                                                />
                                                            </Card.Body>
                                                        </Card>

                                                    </Card.Body>
                                                
                                            </Card>

                                        </Tab>
                                       
                                        <Tab eventKey={6} title={"Sales (" + this.state.entitySalesCount + ")"}>
                                            <Card >
                                                {/* <Card.Header >Sales

                                                </Card.Header> */}

 
                                                <PropertySaleList
                                                    isAuthenticated={this.props.isAuthenticated}
                                                    user={this.props.user}
                                                    data={this.state.entitySales}
                                                    updateTableState={this.updateTableState}
                                                    controlType="table4"
                                                    saveRecord={this.saveRecord}
                                                    deleteRecord={this.deleteRecord}
                                                    refreshDataSet={this.refreshDataSet}
                                                    validateRelatedRecord={this.validateRelatedRecord}
                                                    propertyid={this.state.property_id}
                                                    propertykey={this.state.property_key}
                                                />
                                                                                               
                                            </Card>


                                        </Tab>

                                        <Tab eventKey={7} title={"Sale Sheets (" + this.state.entitySaleSheetsCount + ")"}>



                                            <Card >
                                                {/* <Card.Header >

                                                    Sale Sheets ({this.state.activePropertySaleSheets.length})

                                                </Card.Header> */}

                                                
                                                    <Card.Body>


                                                        <Card >
                                                            <Card.Body>
                                                                <PropertySaleSheetList
                                                                    user={this.props.user}
                                                                    isAuthenticated={this.props.isAuthenticated}
                                                                    data={this.state.entitySaleSheets}
                                                                    updateTableState={this.updateTableState}
                                                                    saveRecord={this.saveRecord}
                                                                    deleteRecord={this.deleteRecord}
                                                                    refreshDataSet={this.refreshDataSet}
                                                                    validateRelatedRecord={this.validateRelatedRecord}
                                                                    controlType="table3"
                                                                    propertyid={this.state.property_id}
                                                                    propertykey={this.state.property_key}
                                                                />
                                                            </Card.Body>
                                                        </Card>

                                                    </Card.Body>
                                                
                                            </Card>
                                        </Tab>


                                    <Tab eventKey={8} title="Record History">
                                        <Card style={{ width: '28rem' }}>
                                            <Card.Body>
                                                <Form.Group as={Row} controlId="created_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_date!= null ? Moment(this.state.created_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="created_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_date!= null ? Moment(this.state.last_edited_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                            </Card.Body>
                                        </Card>

                                    </Tab>


                                </Tabs>

                            </Col>

                        </Row>
                   
                        

                        
                    </Form>
                
                    </div>

                }
            </div>
        );
    }
}